export default "__VITE_ASSET__cZ$TKDe3__"